'use client'

import { usePathname } from 'next/navigation'

// PartnerBar is an async Server Component (it needs `cookies()` via
// resolveActivePartner) and Server Components have no way to read the
// current request's pathname without middleware setting a custom header —
// and src/middleware.ts is off-limits here. usePathname() is the supported
// client-side escape hatch for exactly this: the App Router populates its
// context from the resolved request URL as part of the server render pass
// itself, not merely after hydration, so this renders correctly on the
// first paint with no flash or layout shift — confirmed by rendering it.
//
// On the CDM landing route the page's own hero (see
// src/app/(partners)/partners/cdm/sections/HeroSearch.tsx) already carries
// the co-branded lockup, so showing this fixed bar there too would just
// repeat it. Funnel routes (/hotels, /hotel, /booking, ...) have no such
// hero, so this bar is what carries the partnership there and must keep
// rendering.
export default function PartnerBarRouteGate({
  landingPath,
  children,
}: {
  landingPath: string
  children: React.ReactNode
}) {
  const pathname = usePathname()

  if (pathname === landingPath) return null

  return (
    <>
      {children}
      {/* The site header is `position: fixed; top: 0` (header.scss) and
          out of document flow, so it paints over this bar instead of being
          pushed down by it — measured in a real browser at 1100x560: bar
          top 0/bottom 41, header top/bottom 0/64, fully overlapped. This
          pushes the header (and the site-wide `.header-margin` spacer used
          on every route) down by the bar's own height instead.
          `jsx global` scopes these rules to exist in the DOM only while
          this bar itself is actually mounted — i.e. never on the landing
          route, where the check above already bailed out, and never on
          www.letsroave.com, where PartnerBar returns null before this
          component is ever reached. */}
      <style jsx global>{`
        .header {
          top: 41px;
        }
        .header-margin {
          margin-top: calc(63px + 41px);
        }
        @media (max-width: 767px) {
          .header-margin {
            margin-top: calc(80px + 41px);
          }
        }
      `}</style>
    </>
  )
}
